import React from 'react'
import loadingLogo from "../assets/65ba488626025cff82f091336fbf94bb.gif";
const Loading = () => {
    return (
        <div className={'loadScreen'}>

        <img src={loadingLogo} alt="loading logo"></img>

        </div>
    )
}

export default Loading;